/* Shared by every page: dialogs, the bag (Shopify cart), the menu, the dropdown, Back to top and every film. */
(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
const body = document.body;
const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

/* Money, using the store's money format */
const moneyFormat = body.dataset.moneyFormat || 'Rs. {{amount_no_decimals}}';
function money(cents) {
  const n = Number(cents) / 100;
  const group = (value, decimals, sep = ',', dec = '.') => {
    const [whole, frac] = value.toFixed(decimals).split('.');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (frac ? dec + frac : '');
  };
  return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
    amount: group(n, 2), amount_no_decimals: group(n, 0),
    amount_with_comma_separator: group(n, 2, '.', ','), amount_no_decimals_with_comma_separator: group(n, 0, '.'),
    amount_with_apostrophe_separator: group(n, 2, "'"), amount_with_space_separator: group(n, 2, ' ', ',')
  })[key] ?? group(n, 2));
}

/* Dialogs */
function showDialog(dialog) { if (!dialog) return; dialog.showModal(); body.style.overflow = 'hidden'; }
function wireDialog(d) {
  d.addEventListener('close', () => { body.style.overflow = document.querySelector('dialog[open]') ? 'hidden' : ''; });
  d.addEventListener('click', e => {
    if (e.target.closest('.close-dialog')) { d.close(); return; }
    if (e.target !== d) return;
    const r = d.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
  });
  d.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;
    const nodes = [...d.querySelectorAll('a[href],button:not([disabled]),input,select,summary')].filter(n => n.getClientRects().length);
    if (!nodes.length) return;
    const first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
}
const wired = new WeakSet();
function wireDialogs(root) { $$('dialog', root).forEach(d => { if (!wired.has(d)) { wired.add(d); wireDialog(d); } }); }
wireDialogs(document);

/* Bag */
const bagDialog = $('#bag-dialog'), bagContent = $('#bag-content'), cartPage = $('#cart-page-content');
const paymentListeners = [];
let payment = body.dataset.payment === 'cod' ? 'cod' : 'card';
const productData = (() => { try { return JSON.parse($('#product-data').textContent); } catch { return null; } })();

function continueLabels(scope) {
  if (!productData || !productData.noun || !bagDialog) return;
  const text = bagDialog.dataset.continueProduct.replace('[noun]', productData.noun) + ' ↗';
  $$('[data-action="continue"]', scope).forEach(b => { b.textContent = text; });
}
continueLabels(document);

function applyBag(sections) {
  const html = sections && sections['bag-drawer'];
  if (!html) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const content = $('#bag-content', doc), dialog = $('#bag-dialog', doc);
  if (!content || !dialog) return;
  const count = dialog.dataset.count;
  bagContent.innerHTML = content.innerHTML;
  if (cartPage) cartPage.innerHTML = content.innerHTML;
  bagDialog.dataset.count = count;
  $$('#bag-count').forEach(n => { n.textContent = count; });
  $('#drawer-count').textContent = '(' + count + ')';
  const pageCount = $('#page-bag-count'); if (pageCount) pageCount.textContent = '(' + count + ')';
  continueLabels(bagContent); if (cartPage) continueLabels(cartPage);
}
async function cart(path, data) {
  const res = await fetch(root + path, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ ...data, sections: 'bag-drawer', sections_url: location.pathname })
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw json;
  applyBag(json.sections);
  return json;
}
function notice(text) {
  bagContent.insertAdjacentHTML('afterbegin', '<p role="status" class="bag-shipping"></p>');
  bagContent.firstElementChild.textContent = text;
}
function openBag() { showDialog(bagDialog); }
function inBag(variant) { const row = $('.bag-item[data-variant="' + variant + '"]', bagContent); return row ? Number(row.dataset.qty) : 0; }
async function addToBag(items) {
  if (items.some(i => inBag(i.id) + i.quantity > 99)) { openBag(); notice(bagDialog.dataset.limit); return; }
  try { await cart('cart/add.js', { items }); openBag(); }
  catch (err) { openBag(); notice(err.description || err.message || bagDialog.dataset.error); }
}
async function onBagClick(e) {
  const b = e.target.closest('button[data-action]'); if (!b) return;
  const scope = e.currentTarget;
  const { action, key, qty, variant } = b.dataset;
  if (action === 'continue') {
    if (bagDialog.open) bagDialog.close();
    const target = $('#purchase-form') || $('#essentials');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: target.id === 'purchase-form' ? 'center' : 'start' });
    else location.href = root + 'collections/all';
    return;
  }
  if (action === 'checkout') { location.href = root + 'checkout'; return; }
  b.disabled = true;
  try {
    if (action === 'upsell') await cart('cart/add.js', { items: [{ id: Number(variant), quantity: 1 }] });
    else await cart('cart/change.js', { id: key, quantity: Number(qty) });
  } catch (err) { notice(err.description || err.message || bagDialog.dataset.error); }
  const again = $('[data-action="' + action + '"][data-key="' + key + '"]', scope) || $('.bag-checkout', scope) || $('[data-action="continue"]', scope);
  if (again) again.focus();
}
async function onPayment(e) {
  if (e.target.name !== 'payment') return;
  const scope = e.currentTarget;
  payment = e.target.value; body.dataset.payment = payment;
  for (let i = paymentListeners.length - 1; i >= 0; i--) if (paymentListeners[i].signal && paymentListeners[i].signal.aborted) paymentListeners.splice(i, 1);
  paymentListeners.forEach(l => l.fn(payment));
  try { await cart('cart/update.js', { attributes: { _payment: payment } }); } catch {}
  const radio = $('input[name="payment"][value="' + payment + '"]', scope); if (radio) radio.focus({ preventScroll: true });
}
[bagContent, cartPage].filter(Boolean).forEach(el => { el.addEventListener('click', onBagClick); el.addEventListener('change', onPayment); });
document.addEventListener('click', e => {
  if (e.target.closest('#open-bag')) { openBag(); return; }
  const add = e.target.closest('[data-add-variants]');
  if (add) addToBag(add.dataset.addVariants.split(',').map(id => ({ id: Number(id), quantity: 1 })));
});
window.addEventListener('pageshow', e => {
  if (!e.persisted) return;
  fetch(root + '?sections=bag-drawer').then(r => r.json()).then(applyBag).catch(() => {});
});

/* Mobile menu */
document.addEventListener('click', e => {
  const toggle = e.target.closest('#menu-toggle');
  if (toggle) { const menu = $('#menu-dialog'); showDialog(menu); toggle.setAttribute('aria-expanded', 'true'); return; }
  const menu = e.target.closest('#menu-dialog');
  if (menu && e.target.closest('a')) menu.close();
});
document.addEventListener('close', e => { if (e.target.id === 'menu-dialog') $('#menu-toggle')?.setAttribute('aria-expanded', 'false'); }, true);

/* Desktop dropdown */
const setDrop = (drop, open) => { drop.classList.toggle('open', open); $('.nav-drop-toggle', drop).setAttribute('aria-expanded', String(open)); };
document.addEventListener('click', e => {
  const toggle = e.target.closest('.nav-drop-toggle');
  $$('.nav-drop').forEach(drop => { if (!drop.contains(e.target)) setDrop(drop, false); });
  if (toggle) { const drop = toggle.closest('.nav-drop'); setDrop(drop, !drop.classList.contains('open')); }
});
document.addEventListener('keydown', e => {
  const drop = e.target.closest && e.target.closest('.nav-drop');
  if (e.key === 'Escape' && drop && drop.classList.contains('open')) { setDrop(drop, false); $('.nav-drop-toggle', drop).focus(); }
});
document.addEventListener('focusout', e => {
  const drop = e.target.closest && e.target.closest('.nav-drop');
  if (drop && !drop.contains(e.relatedTarget)) setDrop(drop, false);
});

/* Back to the top */
document.addEventListener('click', e => { if (e.target.closest('[data-back-to-top]')) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); } });

/* Films: Shopify video, .mp4, YouTube, Vimeo or Loom. Every film plays muted and loops on its own. */
const Video = (() => {
  const isNative = el => el.tagName === 'VIDEO';
  const events = new WeakMap();
  function emit(el) { (events.get(el) || []).forEach(fn => fn()); }
  function load(el) {
    if (el.dataset.poster) {
      if (isNative(el)) el.poster = el.dataset.poster; else el.style.backgroundImage = "url('" + el.dataset.poster + "')";
      el.removeAttribute('data-poster');
    }
    if (isNative(el)) {
      const sources = $$('source[data-src]', el);
      if (sources.length) { sources.forEach(s => { s.src = s.dataset.src; s.removeAttribute('data-src'); }); el.load(); }
      return;
    }
    if ($('iframe', el)) return;
    const frame = document.createElement('iframe');
    frame.src = el.dataset.embedSrc;
    frame.title = el.getAttribute('aria-label') || 'Film';
    frame.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('tabindex', '-1');
    el.append(frame);
    el._paused = false; el._muted = true;
    frame.addEventListener('load', () => { if (el._paused) command(el, 'pause'); emit(el); });
  }
  function post(el, message) { const f = $('iframe', el); if (f && f.contentWindow) f.contentWindow.postMessage(typeof message === 'string' ? message : JSON.stringify(message), '*'); }
  function command(el, what, value) {
    const p = el.dataset.provider;
    if (p === 'youtube') post(el, { event: 'command', func: { play: 'playVideo', pause: 'pauseVideo', mute: 'mute', unmute: 'unMute' }[what], args: [] });
    if (p === 'vimeo') post(el, what === 'mute' || what === 'unmute' ? { method: 'setVolume', value: what === 'mute' ? 0 : 1 } : { method: what });
  }
  const controllable = el => isNative(el) || el.dataset.provider === 'youtube' || el.dataset.provider === 'vimeo';
  return {
    load, controllable,
    paused: el => isNative(el) ? el.paused || el.networkState === 3 : !!el._paused,
    muted: el => isNative(el) ? el.muted : el._muted !== false,
    play(el) {
      load(el);
      if (isNative(el)) return el.play().catch(() => emit(el));
      command(el, 'play'); el._paused = false; emit(el);
    },
    pause(el) {
      if (isNative(el)) { el.pause(); return; }
      if (!controllable(el)) return;
      command(el, 'pause'); el._paused = true; emit(el);
    },
    setMuted(el, muted) {
      if (isNative(el)) { el.muted = muted; return; }
      command(el, muted ? 'mute' : 'unmute'); el._muted = muted; emit(el);
    },
    on(el, fn) {
      if (isNative(el)) {
        ['play', 'pause', 'error', 'volumechange'].forEach(ev => el.addEventListener(ev, fn));
        $$('source', el).forEach(s => s.addEventListener('error', fn));
      }
      else events.set(el, [...(events.get(el) || []), fn]);
    }
  };
})();

const pausedByUser = new WeakSet();
function userToggle(el) {
  if (Video.paused(el)) { pausedByUser.delete(el); Video.play(el); }
  else { pausedByUser.add(el); Video.pause(el); }
}
const films = new Set();
const hasIO = 'IntersectionObserver' in window;
// Films further down wait until the page (and its first-screen images) has loaded, then load just before they scroll into view.
const loader = hasIO && new IntersectionObserver(entries => entries.forEach(entry => {
  if (entry.isIntersecting) { Video.load(entry.target); loader.unobserve(entry.target); }
}), { rootMargin: '600px 0px' });
const player = hasIO && new IntersectionObserver(entries => entries.forEach(entry => {
  const el = entry.target;
  if (waiting.has(el)) return;
  if (entry.isIntersecting && !pausedByUser.has(el) && !el.hidden && !document.hidden) Video.play(el);
  else if (!Video.paused(el)) Video.pause(el);
}), { threshold: 0.35 });
let pageLoaded = document.readyState === 'complete';
// A film shown over its poster image starts the moment that poster has appeared (or after 1.5 s at the latest),
// so the poster gets the connection first and the film follows straight after.
const waiting = new WeakSet();
function whenPosterShown(el, go) {
  const poster = el.parentElement && el.parentElement.querySelector('.film-poster');
  if (!poster || (poster.complete && poster.naturalWidth)) return go();
  waiting.add(el);
  let done = false;
  const release = () => { if (done) return; done = true; waiting.delete(el); requestAnimationFrame(go); };
  poster.addEventListener('load', release, { once: true }); poster.addEventListener('error', release, { once: true });
  setTimeout(release, 1500);
}
function startEager(el) {
  Video.load(el);
  const r = el.getBoundingClientRect();
  if (!el.hidden && !pausedByUser.has(el) && !document.hidden && r.bottom > 0 && r.top < innerHeight) Video.play(el);
}
function registerFilms(root) {
  $$('[data-film]', root).forEach(el => {
    if (films.has(el)) return;
    films.add(el);
    if (el.hasAttribute('data-eager')) { if (el.hasAttribute('data-after-poster')) whenPosterShown(el, () => startEager(el)); else Video.load(el); }
    if (!hasIO) { Video.play(el); return; }
    player.observe(el);
    if (!el.hasAttribute('data-eager') && pageLoaded) loader.observe(el);
  });
}
registerFilms(document);
if (!pageLoaded) window.addEventListener('load', () => {
  pageLoaded = true;
  films.forEach(el => { if (!el.hasAttribute('data-eager')) loader && loader.observe(el); });
}, { once: true });
document.addEventListener('visibilitychange', () => {
  films.forEach(el => {
    if (!el.isConnected) { films.delete(el); return; }
    if (document.hidden) { if (!Video.paused(el)) Video.pause(el); }
    else if (!pausedByUser.has(el) && !el.hidden) {
      const r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) Video.play(el);
    }
  });
});

/* Play / pause buttons and reel sound buttons */
const wiredButtons = new WeakSet();
function wireToggle(button, el, labels) {
  if (!button || !el || wiredButtons.has(button)) return;
  wiredButtons.add(button);
  if (!Video.controllable(el)) { button.hidden = true; return; }
  const sync = () => labels(Video.paused(el));
  button.addEventListener('click', () => userToggle(el));
  Video.on(el, sync); sync();
}
function wireFilmButtons(root) {
  const text = (productData && productData.text) || {};
  $$('.reel-play, .film-toggle[data-video]', root).forEach(button => wireToggle(button, document.getElementById(button.dataset.video), paused => {
    button.textContent = paused ? (text.playFilm || 'Play film ▷') : (text.pauseFilm || 'Pause film Ⅱ');
    button.setAttribute('aria-label', (paused ? 'Play' : 'Pause') + ' product film');
  }));
  $$('.reel-mute', root).forEach(button => {
    const el = document.getElementById(button.dataset.video);
    if (!el || wiredButtons.has(button)) return;
    wiredButtons.add(button);
    if (!Video.controllable(el)) { button.hidden = true; return; }
    button.addEventListener('click', () => {
      Video.setMuted(el, !Video.muted(el));
      const muted = Video.muted(el);
      button.textContent = muted ? 'Sound off' : 'Sound on';
      button.setAttribute('aria-pressed', String(!muted));
      button.setAttribute('aria-label', (muted ? 'Unmute' : 'Mute') + ' reel');
    });
  });
}
wireFilmButtons(document);

/* Page scripts register with mount(); in the theme editor they restart whenever a section is re-drawn. */
const mounts = [];
function mount(init) {
  const entry = { init, controller: null };
  mounts.push(entry); start(entry);
}
function start(entry) {
  if (entry.controller) entry.controller.abort();
  entry.controller = new AbortController();
  const signal = entry.controller.signal;
  if (!(window.Shopify && Shopify.designMode)) { entry.init(signal); return; }
  // In the editor only: tie every listener the script adds to this run, so a restart never doubles them up.
  const add = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function (type, fn, opts) {
    const o = typeof opts === 'object' && opts ? { ...opts, signal } : { capture: !!opts, signal };
    return add.call(this, type, fn, o);
  };
  try { entry.init(signal); } finally { EventTarget.prototype.addEventListener = add; }
}
document.addEventListener('shopify:section:load', e => {
  wireDialogs(e.target); registerFilms(e.target); wireFilmButtons(e.target); continueLabels(e.target);
  mounts.forEach(start);
});

window.BotanifolSite = {
  $, $$, money, showDialog, addToBag, openBag, Video, userToggle, wireToggle, pausedByUser, mount,
  getPayment: () => payment,
  onPaymentChange: (fn, signal) => {
    paymentListeners.push({ fn, signal });
  }
};
})();
